import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import Select from "@components/form/Select2";
import SelectCity from "@components/form/SelectCity";
import FilterButtons from "../pages/networking/components/FilterButtons";

interface PropsInterface extends Type.ComponentInterface {
  isNetworkingPage?: boolean;
  isAdaptive?: boolean;
  catalog: string;
  callback?: (filters: any, newViewCompanies: any, newViewUsers: any) => void;
  onClearQuery: () => void;
  onClick: (typeCatalog: string) => void;
}

interface StateInterface {
  showFilter: boolean;
  specFilterShow: boolean;
  typeFilterShow: boolean;
  showCompanies: boolean;
  showEmployes: boolean;
  types: number[];
  specializations: number[];
  typesGroupsHided: number[];
  direction: number | null;
  city: number[];
  companiesShow: boolean;
  usersShow: boolean;
  selectedFilter: string;
  countVisibleItems: number;
}

class NetworkingFilterComponent extends React.Component<
  PropsInterface,
  StateInterface
> {
  public constructor(Props: PropsInterface) {
    super(Props);
    this.state = {
      showFilter: true,
      specFilterShow: true,
      typeFilterShow: true,
      showCompanies: true,
      showEmployes: true,
      types: [],
      specializations: [],
      typesGroupsHided: [],
      direction: null,
      city: [],
      companiesShow: true,
      usersShow: true,
      selectedFilter: "all",
      countVisibleItems: 3,
    };
    this.onCheckHandler = this.onCheckHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.clear = this.clear.bind(this);
    this.clearCountry = this.clearCountry.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.clearParam = this.clearParam.bind(this);
  }

  public componentDidMount() {
    this.setState(
      {
        types: JSON.parse(
          new URLSearchParams(this.props.location.search).get("types") || "[]"
        ),
        specializations: JSON.parse(
          new URLSearchParams(this.props.location.search).get(
            "specializations"
          ) || "[]"
        ),
        direction: JSON.parse(
          new URLSearchParams(this.props.location.search).get("direction") ||
            "null"
        ),
        city: JSON.parse(
          new URLSearchParams(this.props.location.search).get("city") || "[]"
        ),
      },
      () => this.callback()
    );
  }

  public componentDidUpdate(props: PropsInterface) {
    if (this.props.location.search !== props.location.search) {
      this.setState({
        types: JSON.parse(
          new URLSearchParams(this.props.location.search).get("types") || "[]"
        ),
        specializations: JSON.parse(
          new URLSearchParams(this.props.location.search).get(
            "specializations"
          ) || "[]"
        ),
        direction: JSON.parse(
          new URLSearchParams(this.props.location.search).get("direction") ||
            "null"
        ),
        city: JSON.parse(
          new URLSearchParams(this.props.location.search).get("city") || "[]"
        ),
      });
    }
  }

  private clear(event: any) {
    this.props.onClearQuery();
    this.setState(
      {
        showCompanies: true,
        showEmployes: true,
        types: [],
        specializations: [],
        direction: null,
        city: [],
        companiesShow: true,
        usersShow: true,
        selectedFilter: "all",
        countVisibleItems: 3,
        typesGroupsHided: [],
      },
      () => {
        const params = new URLSearchParams(this.props.location.search);
        params.delete("types");
        params.delete("specializations");
        params.delete("direction");
        params.delete("city");
        this.props.history.replace({ search: params.toString() });
        setTimeout(() => this.callback(), 1000);
        console.log("FINALLY PARAMS: ", params);
      }
    );
  }

  clearCountry() {
    this.setState({ direction: null }, () => {
      const params = new URLSearchParams(this.props.location.search);

      params.delete("direction");
      this.props.history.replace({ search: params.toString() });
      setTimeout(() => this.callback(), 1000);
    });
  }

  clearParam(paramName: string, paramId: number) {
    const params = new URLSearchParams(this.props.location.search);

    const param = params.get(paramName);
    if (!param) return;

    let idArray: number[] = JSON.parse(param);

    idArray = idArray.filter((id: number) => id !== paramId);

    if (idArray.length === 0) {
      params.delete(paramName);
    } else {
      params.set(paramName, JSON.stringify(idArray));
    }
    this.props.history.replace({ search: params.toString() });
  }

  renderCompaniesCount(count: number) {
    if (count !== 0 && count !== undefined) {
      return <span>{count}</span>;
    }
  }

  handleShowMore() {
    this.setState({
      countVisibleItems: this.props.Store.Company.Specialization?.list?.length,
    });
  }

  private renderItems(Group: any, inGroup: boolean = false) {
    const items: JSX.Element[] = [];
    Group.itemList.map((Item: any) => {
      items.push(
        <div
          className={`netw-filter__${inGroup ? "subgroup" : "group"}-item`}
          key={Item.id}
        >
          <input
            tabIndex={0}
            className="visually-hidden"
            id={Item.id + "types"}
            type="checkbox"
            name="types"
            value={Item.id}
            checked={this.state.types.includes(Item.id)}
            onChange={this.onCheckHandler}
          />
          <label htmlFor={Item.id + "types"}>
            {Item.name}
            {this.renderCompaniesCount(Item.companiesCount)}
          </label>
        </div>
      );
    });
    return items;
  }

  private onChangeHandler(
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void {
    this.setState({ [event.target.name]: event.target.value }, () => {
      this.callback();
    });
  }

  private onCheckHandler(
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void {
    const list = this.state[event.target.name];
    if (list.includes(Number(event.target.value))) {
      list.splice(list.indexOf(Number(event.target.value)), 1);
    } else {
      list.push(Number(event.target.value));
    }
    this.clearParam(event.target.name, Number(event.target.value));
    this.setState({ [event.target.name]: list }, () => {
      this.callback();
    });
  }

  public callback() {
    const filters: any = {};

    if (this.state.specializations.length) {
      filters.specializations = this.state.specializations;
    }
    if (this.state.types.length) {
      filters.types = this.state.types;
    }
    if (this.state.direction) {
      filters.direction = this.state.direction;
    }
    if (this.state.city.length) {
      filters.city = this.state.city;
    }

    let searchParams: any = {};
    const params = new URLSearchParams(this.props.location.search);
    for (const param of params) {
      searchParams[param[0]] = JSON.parse(param[1]);
    }
    searchParams = { ...searchParams, ...filters };

    const url = new URL(window.location.href.split("?")[0]);
    const keys = Object.keys(searchParams);
    keys.forEach((key: any) => {
      const value = searchParams[key];

      if (Array.isArray(value) ? value.length : value) {
        url.searchParams.set(key, JSON.stringify(value));
      }
    });

    this.props.history.push(
      url.toString().slice(url.protocol.length + 2 + url.host.length)
    );
    if (this.props.callback) {
      this.props.callback(
        filters,
        this.state.companiesShow,
        this.state.usersShow
      );
    }
  }

  public render() {
    return (
      <div className="netw__filter">
        <div className="netw__header-filters--mobile">
          <div className="netw__filter-title">Каталог</div>
          <div className="netw__panel-wrapper">
            {this.props.Store.Profile?.data?.useNetworking ? (
              <FilterButtons
                catalog={this.props.catalog}
                onClick={this.props.onClick}
              />
            ) : null}
          </div>
          <div className="netw__search-wrapper">
            <input
              className="netw__search"
              id="search"
              type="text"
              name="search"
              value={this.state.searchQuery}
              placeholder="Найти представителя"
              onChange={(e) => {
                this.setState({ ...this.state, searchQuery: e.target.value });
                if (e.target.value.length > 2) {
                  Middleware.Networking.Search.list(e.target.value);
                }
                if (!e.target.value.length) {
                  Middleware.Networking.Search.clear();
                }
              }}
            />
          </div>
          <button
            className="netw__filter-btn js-filter-trigger"
            type="button"
            onClick={() =>
              this.setState({ showFilter: !this.state.showFilter })
            }
          >
            Фильтр
          </button>
          {this.state.direction ||
          this.state.types.length ||
          this.state.specializations.length ||
          this.state.city.length ||
          this.state.typesGroupsHided.length ? (
            <button
              className="btn btn--filter-reset netw-filter__reset-btn"
              type="button"
              onClick={this.clear}
            >
              Сбросить фильтр{" "}
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 1L5 5M5 5L1 1M5 5L1 9M5 5L9 9" stroke="#ff0011" />
              </svg>
            </button>
          ) : null}
        </div>
        <div
          className={`netw-filter ${
            this.state.showFilter ? "" : "netw-filter--closed"
          } ${this.props.isAdaptive ? "netw-filter--adaptive" : ""}`}
        >
          <button
            className="netw-filter__close js-filter-trigger"
            type="button"
            onClick={() => this.setState({ showFilter: false })}
          />
          <div className="netw-filter__title-wrapper">
            <div className="netw-filter__title">Фильтр</div>
            {this.state.direction ||
            this.state.types.length ||
            this.state.specializations.length ||
            this.state.city.length ||
            this.state.selectedFilter !== "all" ||
            this.state.typesGroupsHided.length ? (
              <button
                className="btn btn--filter-reset netw-filter__reset-btn"
                type="button"
                onClick={this.clear}
              >
                Сбросить фильтр{" "}
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9 1L5 5M5 5L1 1M5 5L1 9M5 5L9 9" stroke="#ff0011" />
                </svg>
              </button>
            ) : null}
          </div>
          <hr />
          {this.props.isNetworkingPage ? (
            <>
              <div className="netw-filter__filter">
                <div className="netw-filter__filter-body">
                  <div className="netw-filter__filter-item">
                    <label htmlFor="filter-company">
                      <input
                        id="filter-company"
                        type="radio"
                        name="filter"
                        checked={this.state.selectedFilter === "companies"}
                        onChange={() =>
                          this.setState(
                            {
                              companiesShow: true,
                              usersShow: false,
                              selectedFilter: "companies",
                            },
                            () => this.callback()
                          )
                        }
                      />
                      Компании
                      <span>{this.props.Store.Networking.Company.count}</span>
                    </label>
                  </div>
                  <div className="netw-filter__filter-item">
                    <label htmlFor="filter-people">
                      <input
                        id="filter-people"
                        type="radio"
                        name="filter"
                        checked={this.state.selectedFilter === "users"}
                        onChange={() =>
                          this.setState(
                            {
                              usersShow: true,
                              companiesShow: false,
                              selectedFilter: "users",
                            },
                            () => this.callback()
                          )
                        }
                      />
                      Люди
                      <span>{this.props.Store.Networking.User.count}</span>
                    </label>
                  </div>
                  <div className="netw-filter__filter-item">
                    <label htmlFor="filter-all">
                      <input
                        id="filter-all"
                        type="radio"
                        name="filter"
                        checked={this.state.selectedFilter === "all"}
                        onChange={() =>
                          this.setState(
                            {
                              usersShow: true,
                              companiesShow: true,
                              selectedFilter: "all",
                            },
                            () => this.callback()
                          )
                        }
                      />
                      Все
                      <span>
                        {this.props.Store.Networking.User.count +
                          this.props.Store.Networking.Company.count}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <hr />
            </>
          ) : (
            <></>
          )}
          <div className="netw-filter__country">
            <p className="netw-filter__group-header">Направления компании</p>
            <Select
              name="direction"
              value={this.state.direction}
              clear={this.clearCountry}
              onChange={this.onChangeHandler}
              options={this.props.Store.Company.Direction.list?.filter(
                (Direction: any) => Direction.count > 0
              )}
              required={false}
              placeholder="Выбрать"
              hasChevron={true}
            />
          </div>
          <hr />
          <div className="netw-filter__city">
            <div className="netw-filter__group-header">Город компании</div>
            <SelectCity
              name="city"
              selected={this.state.city}
              onChange={this.onCheckHandler}
              options={this.props.Store.Company.City.list}
              placeholder="Город"
            />
          </div>
          <hr />
          <div className="netw-filter__main">
            <div
              className={`netw-filter__group ${
                this.state.specFilterShow ? "" : "netw-filter__group--closed"
              }`}
            >
              <div
                className="netw-filter__group-header"
                // onClick={() =>
                //   this.setState({
                //     specFilterShow: !this.state.specFilterShow,
                //   })
                // }
              >
                Специализация
                {/* <div className="netw-filter__group-arrow" /> */}
              </div>
              <div
                className={`netw-filter__group-body 
                  ${
                    this.state.countVisibleItems > 3
                      ? "netw-filter__group-body-spoiler--open"
                      : "netw-filter__group-body-spoiler"
                  }
                `}
              >
                {this.props.Store.Company.Specialization?.list
                  ?.slice(0, this.state.countVisibleItems)
                  .map((Item: any, index: number) => {
                    return (
                      <div className="netw-filter__group-item" key={Item.id}>
                        <label htmlFor={Item.id + "specializations"}>
                          <input
                            id={Item.id + "specializations"}
                            type="checkbox"
                            name="specializations"
                            value={Item.id}
                            checked={this.state.specializations.includes(
                              Item.id
                            )}
                            onChange={this.onCheckHandler}
                          />
                          {Item.name}{" "}
                          {this.state.specializations.includes(Item.id)}
                          {this.renderCompaniesCount(Item.companiesCount)}
                        </label>
                      </div>
                    );
                  })}
              </div>
              {this.state.countVisibleItems <
                this.props.Store.Company.Specialization?.list?.length && (
                <button
                  className="netw-filter__show-more-button"
                  onClick={this.handleShowMore}
                >
                  <span>Показать ещё</span>
                  <img
                    src={require("@public/images/icons/chevron-down-gray.svg")}
                    alt="Иконка"
                  />
                </button>
              )}
            </div>
            <hr />
            <div
              className={`netw-filter__group ${
                this.state.typeFilterShow ? "" : "netw-filter__group--closed"
              }`}
            >
              <div
                className="netw-filter__group-header"
                // onClick={() =>
                //   this.setState({
                //     typeFilterShow: !this.state.typeFilterShow,
                //   })
                // }
              >
                Тип компании
                {/* <div className="netw-filter__group-arrow" /> */}
              </div>
              <div className="netw-filter__group-body">
                {this.props.Store.Company.Type?.groups.map((Group: any) => {
                  if (Group.id !== 0) {
                    return (
                      <div
                        className={`netw-filter__subgroup${
                          !this.state.typesGroupsHided.includes(Group.id)
                            ? "--closed"
                            : ""
                        }`}
                        key={Group.id}
                      >
                        <div
                          className="netw-filter__subgroup-header"
                          onClick={(e) => {
                            const typesGroupsHided =
                              this.state.typesGroupsHided || [];
                            if (typesGroupsHided.includes(Group.id)) {
                              const i = typesGroupsHided.indexOf(Group.id);
                              typesGroupsHided.splice(i, 1);
                            } else {
                              typesGroupsHided.push(Group.id);
                            }
                            typesGroupsHided.sort((a, b) => a - b);
                            this.setState({ typesGroupsHided });
                          }}
                        >
                          {Group.name.replace(/:/g, "")}
                          {this.renderCompaniesCount(Group.companiesCount)}
                          <div className="netw-filter__subgroup-arrow" />
                        </div>
                        <div className="netw-filter__subgroup-body">
                          {this.renderItems(Group, true)}
                        </div>
                      </div>
                    );
                  } else {
                    return this.renderItems(Group, true);
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(NetworkingFilterComponent)
);
